const A = "0x1626ba7e";
export {
  A as GNOSIS_SAFE_UPDATED_MAGIC_VALUE
};
//# sourceMappingURL=login.js.map
